import { Nullable } from './common';

export function getWorkspaceTitlePrefix(companyName: Nullable<string>) {
  if (!companyName || companyName.toLowerCase() === 'assembly') {
    return 'Assembly';
  }
  return `${companyName} - Assembly`;
}
